import * as auth from './auth.js';
import { apiGet } from './api.js';
import { setState } from './store.js';
import { mountLayout } from './components/layout.js';

/**
 * Re-prime the app shell after any auth state change.
 *
 * - When authenticated: refresh /household into store so the layout (user menu,
 *   admin tabs) renders with current identity.
 * - When unauthenticated: clear stale household state so a previous user's
 *   data doesn't leak into the login page or a subsequent session.
 * - Always re-mount the layout so it reflects the new auth state.
 *
 * Safe to call repeatedly. Callers must `router.rerender()` or `router.go(...)`
 * afterwards if they need the page content to redraw too.
 */
export async function mountAuthedShell() {
  if (auth.isAuthenticated()) {
    try {
      const household = await apiGet('/household');
      setState({ household });
    } catch {
      // Leave whatever household is in store; layout falls back to defaults.
    }
  } else {
    setState({ household: null });
  }
  const root = document.getElementById('app');
  mountLayout(root);
}
